import React, { Fragment, useEffect, useState } from 'react';
import axios from 'axios'
import { useLocation, Navigate } from 'react-router-dom';

// Import API config object
import { tokenConfig } from '../utils/apiConfig'

// Import Navbar to be displayed
import NavBar from '../components/NavBar'
import LoadingScreen from '../components/LoadingScreen';

function loginPages(LoginComponent, requiredAuth = false, hideNavbar = false) {
    const Authenticate = props => {
        const location = useLocation()
        // Auth Constants to manage displays of protected paths
        const [authenticated, setAuthenticated] = useState(false)
        const [invalidToken, setInvalidToken] = useState(false)
        const [userDetails, setUserDetails] = useState(null)
        const [loading, setLoading] = useState(true)
        //Triggering Authentication
        useEffect(() => {
            setLoading(true)
            const auth = async () => {
                await axios.get('/api/auth/user', tokenConfig())
                    .then(res => {
                        setAuthenticated(true)
                        setUserDetails(res.data)
                        setLoading(false)
                    })
                    .catch(err => {
                        localStorage.clear()
                        console.log(err)
                        setInvalidToken(true)
                        setUserDetails(null)
                        setLoading(false)
                    });
            }

            auth()
        }, [authenticated])

        useEffect(() => {
            if (location.state?.requireRefresh) {
                window.history.replaceState(null, document.title, `${location.pathname}${location.search}${location.hash}`)
                window.location.reload()
            }
        }, [location])

        if (loading) {
            return <LoadingScreen />
        }

        const currentPath = window.location.pathname

        if (requiredAuth && !authenticated && currentPath !== '/') {
            return <Navigate replace to="/" />
        }

        return (
            <Fragment>
                <NavBar authenticated={authenticated} hideNavbar={hideNavbar} invalidToken={invalidToken} setAuthenticated={setAuthenticated} userDetails={userDetails} />
                <LoginComponent authenticated={authenticated} userDetails={userDetails} setUserDetails={setUserDetails} loading={loading} {...props} />
            </Fragment>
        )
    }
    return Authenticate
}

export default loginPages
